import axiosInstance from "../../apiAxios/axiosInstance";

export const PendingKycList = async(payload) => {
  const response= await axiosInstance.get("/admin/kyc-pending-request",payload);
   return response.data;
};

export const ApprovedKycList = async(payload) => {
   const resposne=await axiosInstance.get("/admin/active-category-list",payload);
   return resposne.data
};
export const VendorKycDataGet = async(payload) => {
   const resposne=await axiosInstance.post("/admin/admin-vendor-kyc-dataGet",payload);
   return resposne.data
};
export const updateKyc = async(payload) => {
   const resposne=await axiosInstance.post("/admin/admin-vendor-kyc-update",payload);
   return resposne.data
};

export const RejectedKycList = async(payload) => {
const response= await axiosInstance.get("/admin//kyc-rejected-request", payload);
    return response.data;
};
export const KycChangeStatusList = async(payload) => {
const response= await axiosInstance.post("/admin/kyc-status-update", payload);
    return response.data;
};
